import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return { Authorization: `Bearer ${token}` };
};

export const timetableApi = {
  getAll: () => axios.get(`${API}/timetable`, { headers: getAuthHeaders() }),
  create: (data) => axios.post(`${API}/timetable`, data, { headers: getAuthHeaders() }),
  update: (id, data) => axios.put(`${API}/timetable/${id}`, data, { headers: getAuthHeaders() }),
  delete: (id) => axios.delete(`${API}/timetable/${id}`, { headers: getAuthHeaders() })
};

export const assignmentsApi = {
  getAll: () => axios.get(`${API}/assignments`, { headers: getAuthHeaders() }),
  create: (data) => axios.post(`${API}/assignments`, data, { headers: getAuthHeaders() }),
  update: (id, data) => axios.put(`${API}/assignments/${id}`, data, { headers: getAuthHeaders() }),
  delete: (id) => axios.delete(`${API}/assignments/${id}`, { headers: getAuthHeaders() })
};

export const revisionApi = {
  getSubjects: () => axios.get(`${API}/revision/subjects`, { headers: getAuthHeaders() }),
  createSubject: (data) => axios.post(`${API}/revision/subjects`, data, { headers: getAuthHeaders() }),
  getNotes: (subjectId) => {
    const params = subjectId ? `?subject_id=${subjectId}` : '';
    return axios.get(`${API}/revision/notes${params}`, { headers: getAuthHeaders() });
  },
  createNote: (data) => axios.post(`${API}/revision/notes`, data, { headers: getAuthHeaders() }),
  updateNote: (id, data) => axios.put(`${API}/revision/notes/${id}`, data, { headers: getAuthHeaders() }),
  deleteNote: (id) => axios.delete(`${API}/revision/notes/${id}`, { headers: getAuthHeaders() })
};